import { motion, AnimateSharedLayout } from 'framer-motion'

import { Button } from '@tracklib/kit'

// Hooks
import { useSubscription } from 'modules/subscription/hooks'

import styles from './periodswitch.css'

type PeriodSwitchProps = {
  periods: Array<{ months: number; id: number; label: string }>
  selectedMonths: number
  disableButtons?: boolean
  setSelectedMonths: (months: number) => void
}

const PeriodSwitch = ({ periods, selectedMonths, disableButtons, setSelectedMonths }: PeriodSwitchProps): JSX.Element => {
  const subscription = useSubscription()
  const hasCancelledSubscription = subscription?.state === 'CANCELLED'
  return (
    <>
      <div className={styles.periodButtons}>
        <AnimateSharedLayout transition={{ duration: 0.2 }}>
          {periods
            .sort((a, b) => a.months - b.months)
            .map(({ months, id, label }) => {
              const selected = months === selectedMonths
              const current = !hasCancelledSubscription && subscription?.next_renewal_period?.months === months
              return (
                <Button
                  key={id}
                  className={selected ? styles.periodButtonSelected : styles.periodButton}
                  onClick={() => !disableButtons && setSelectedMonths(months)}
                  datatesting={`button_period_months_${months}`}
                >
                  {selected && <motion.span layoutId="background" className={styles.periodButtonSelectedBackground} />}
                  {label && (
                    <span className={styles.label}>
                      {label}
                      {current && <span> (Current)</span>}
                    </span>
                  )}
                </Button>
              )
            })}
        </AnimateSharedLayout>
      </div>
      <p className={styles.periodText}>Get 2 months free when you pay annually</p>
    </>
  )
}

export default PeriodSwitch
